import PhotoUploader from './PhotoUploader.jsx';
import TextSubmission from './TextSubmission.jsx';
import PhotoAndTextSubmission from './PhotoAndTextSubmission.jsx';
import MultiPhotoSubmission from './MultiPhotoSubmission.jsx';

// Picks the right submission UI for a transmission based on its
// submission_type. Falls through to a neutral placeholder for the
// peer_attestation flow, which is still group-vote-only at trip time.

export default function ChallengeSubmit({ transmission, tripId, playerId, testMode, onVerified }) {
  if (!transmission) return null;
  const challengeId = transmission.challenge_id;
  const type = transmission.submission_type;

  switch (type) {
    case 'photo':
      return (
        <PhotoUploader
          tripId={tripId}
          playerId={playerId}
          challengeId={challengeId}
          testMode={testMode}
          onVerified={onVerified}
        />
      );
    case 'text':
      return (
        <TextSubmission
          tripId={tripId}
          playerId={playerId}
          challengeId={challengeId}
          testMode={testMode}
          onVerified={onVerified}
        />
      );
    case 'photo_and_text':
      return (
        <PhotoAndTextSubmission
          tripId={tripId}
          playerId={playerId}
          challengeId={challengeId}
          testMode={testMode}
          onVerified={onVerified}
        />
      );
    case 'multi_photo':
      return (
        <MultiPhotoSubmission
          tripId={tripId}
          playerId={playerId}
          challengeId={challengeId}
          testMode={testMode}
          required={transmission.required_submissions || 3}
          onVerified={onVerified}
        />
      );
    case 'none':
      // Transmission-only — Wilman speaks, no submission expected.
      // Used for atmosphere cues (welcome on landing, day-end recaps).
      return (
        <p className="rounded-md border border-dashed border-border-tertiary bg-bg-secondary px-4 py-3 font-mono text-[11px] text-fg-tertiary">
          transmission only · no submission required
        </p>
      );
    case 'peer_attestation':
      return <Placeholder label="Peer attestation · group vote in person" />;
    default:
      return <Placeholder label={`Unsupported submission type · ${type}`} />;
  }
}

function Placeholder({ label }) {
  return (
    <div className="rounded-md border border-dashed border-border-tertiary bg-bg-secondary px-4 py-3 font-mono text-[11px] text-fg-tertiary">
      {label}
    </div>
  );
}
